import React from 'react';
// Inlined header to avoid module-resolution issues with Header component
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';
import Header from '../components/Header';

export default function FAQPage() {
  return (
    <div className="page-shell min-h-screen">
      <Header />

      <section className="relative overflow-hidden py-14 px-5 sm:px-8">
        <div className="pointer-events-none absolute -right-32 top-0 h-72 w-72 rounded-full bg-[#f2643f]/12 blur-[80px]" />
        <div className="pointer-events-none absolute -left-32 bottom-0 h-72 w-72 rounded-full bg-[#3182ce]/12 blur-[80px]" />
        <div className="relative mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-[#f6c7b4] bg-[#fff1e8] px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[var(--brand-accent)]">
            Support Center
          </span>
          <h1 className="mt-5 text-5xl font-extrabold tracking-tight text-[var(--brand-ink)] sm:text-6xl">
            Frequently Asked<br />Questions
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-[var(--text-muted)]">
            Everything you need to understand your subscription management, cancellation process, and support access.
          </p>
        </div>
      </section>

      <main className="mt-2 px-4 py-8 sm:px-6 lg:mt-3 lg:px-8 lg:py-10">
        <div className="mx-auto max-w-5xl px-2 sm:px-0">
          <section>
            <div className="space-y-6">
              <FAQItem  title="Why do I have a Digitalbookshelfcare.com charge on my bank statement?" icon={<FiHeart />}>
                If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of Digitalbookshelfcare.com, but a client of a site that has delegated the management of its customer service.
              </FAQItem>

              <FAQItem title="What are the services offered by Digitalbookshelfcare.com?" icon={<FiFlag />}>
                Digitalbookshelfcare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.
              </FAQItem>

              <FAQItem title="What kind of subscription do you need for after-sales service?" icon={<FiSearch />}>
                Digitalbookshelfcare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.
              </FAQItem>

              <FAQItem title="I do not remember signing up to a Digitalbookshelfcare.com subscription." icon={<FiShare2 />}>
                You have not signed up to a Digitalbookshelfcare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.
              </FAQItem>

              <FAQItem title="How to find the offer to which I subscribed?" icon={<FiLink />}>
                Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.
              </FAQItem>

              <FAQItem title="I forgot the email address used when subscribing. What can I do?" icon={<FiUser />}>
                If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.
              </FAQItem>

              <FAQItem title="Who can I contact if I have a question?" icon={<FiMessageCircle />}>
                Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.
              </FAQItem>

              <FAQItem title="How can I cancel my subscription?" icon={<FiUsers />}>
                Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.
              </FAQItem>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

